<template>
  <div id="vacancyview" class="vacancyview" v-loading.body="loading">
    <span v-if="isReadOnly">
      <div style="padding:5px; height: 50px">
        <el-button style="float:right;width:150px;height:36px;" type="danger" icon="close" @click="cancel">
          Отмена
        </el-button>
        <el-button style="float:right;width:150px;height:36px;margin-right:10px;" type="success" icon="edit" @click="enroll">
          Подать заявку
        </el-button>
        <el-dialog title="Загрузите заявление на участие в конкурсе" :visible.sync="docDialogVisible" size="small" :close-on-click-modal="false" :show-close="false" :close-on-press-escape="false">
          <el-upload
            drag
            class="upload-demo"
            ref="upload"
            :action="uploadUrl"
            :headers="uploadRequestHeaders"
            :auto-upload="false"
            :fileList = "fileList"
            :before-upload="beforeUpload"
            :on-change="changeFileList"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            list-type="picture"
            style="width:100%; padding:10px;"
            >
            <i class="el-icon-upload" style="width:100%"></i>
            <div class="el-upload__text"><em>Нажмите на область для выбора файла</em></div>
            <div class="el-upload__tip" slot="tip" style="width:100%; text-align:center;">
              jpg/jpeg/png/pdf файлы размером меньше, чем 5MB
            </div>
          </el-upload>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="acceptAttachment">Загрузить</el-button>
            <el-button @click="cancelAttachment">Отмена</el-button>
          </span>
        </el-dialog>
      </div>
      <div style="padding:5px;" class="readonly">
        <el-form :model="currentVacancy" ref="vacancy" label-width="220px">
          <el-form-item label="Должность">
            <b>{{currentVacancy.position}}</b>
          </el-form-item>
          <el-form-item label="Тип конкурса">
            <b>{{currentVacancy.contestTypeLabel}}</b>
          </el-form-item>
          <el-form-item label="Орган исполнительной власти">
            <b>{{currentVacancy.comitteeLabel}}</b>
          </el-form-item>
          <el-form-item label="Дата подачи документов с" style="width:100%;">
           <el-col :span="3">
             <b>{{formatDate(currentVacancy.dateDocumentsAppliedFrom)}}</b>
           </el-col>
           <el-col class="line" :span="1">по</el-col>
           <el-col :span="20" style="">
              <b>{{formatDate(currentVacancy.dateDocumentsAppliedTo)}}</b>
           </el-col>
         </el-form-item>
         <el-form-item label="Предварительная дата">
           <b>{{formatDate(currentVacancy.dateOfContestPreliminary)}}</b>
         </el-form-item>
         <el-form-item label="Дата проведения">
           <b>{{formatDate(currentVacancy.dateOfContest)}}</b>
         </el-form-item>
         <el-form-item label="Дата проведения второго этапа">
           <b>{{formatDate(currentVacancy.dateOfSecondStage)}}</b>
         </el-form-item>
         <el-form-item label="Контакты">
           <b>{{currentVacancy.contacts}}</b>
         </el-form-item>
         <el-form-item label="Место проведения">
           <b>{{currentVacancy.place}}</b>
         </el-form-item>
          <el-form-item label="Описание">
            <span v-html="currentVacancy.description"/>
          </el-form-item>
        </el-form>
      </div>
    </span>
    <span v-else>
      <div style="padding:5px; height: 50px">
        <el-button style="float:right;width:150px;height:36px;" type="danger" icon="close" @click="cancel">
          Отмена
        </el-button>
        <el-button style="float:right;width:150px;height:36px;margin-right:10px;" type="success" icon="edit" @click="save">
          Сохранить
        </el-button>
      </div>
      <div style="padding:5px;">
        <el-form :model="currentVacancy" :rules="vacancyRules" ref="vacancy" label-width="220px">
          <el-form-item label="Должность" prop="position">
            <el-input placeholder="Введите должность" v-model="currentVacancy.position">
            </el-input>
          </el-form-item>
          <el-form-item label="Тип конкурса" prop="contestType">
            <el-select v-model="currentVacancy.contestType" placeholder="Выберите тип конкурса" style="width:100%;" filterable>
              <el-option
                v-for="item in contestTypes"
                :key="item.id"
                :label="item.label"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Орган исполнительной власти" prop="comitteeId">
            <el-select v-model="currentVacancy.comitteeId" placeholder="Выберите орган исполнительной власти" style="width:100%;" filterable>
              <el-option
                v-for="item in comittees"
                :key="item.id"
                :label="item.label"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
           <el-form-item label="Дата подачи документов с" prop="dateDocumentsAppliedFrom" style="width:100%;">
            <el-col :span="12">
              <el-date-picker v-model="currentVacancy.dateDocumentsAppliedFrom" type="date" format="dd.MM.yyyy" text="" placeholder="Выберите дату">
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="1">по</el-col>
            <el-col :span="11" style="">
              <el-date-picker v-model="currentVacancy.dateDocumentsAppliedTo" type="date" format="dd.MM.yyyy" text="" placeholder="Выберите дату">
              </el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="Предварительная дата" prop="dateOfContestPreliminary">
            <el-date-picker v-model="currentVacancy.dateOfContestPreliminary" type="date" format="dd.MM.yyyy" text="" placeholder="Выберите дату">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="Дата проведения">
            <el-date-picker v-model="currentVacancy.dateOfContest" type="date" format="dd.MM.yyyy" text="" placeholder="Выберите дату">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="Дата проведения второго этапа">
            <el-date-picker v-model="currentVacancy.dateOfSecondStage" type="date" format="dd.MM.yyyy" text="" placeholder="Выберите дату">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="Контакты" prop="contacts">
            <el-input placeholder="Введите контакты" v-model="currentVacancy.contacts">
            </el-input>
          </el-form-item>
          <el-form-item label="Место проведения" prop="place" type="textarea" :rows="2">
            <el-input placeholder="Введите место проведения" v-model="currentVacancy.place">
            </el-input>
          </el-form-item>
          <el-form-item label="Результат" prop="status">
            <el-select v-model="currentVacancy.status" placeholder="Выберите статус" style="width:100%;" :disabled="isStatusReadOnly" filterable>
              <el-option
                v-for="item in statuses"
                :key="item.id"
                :label="item.label"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Описание" prop="description">
            <el-input
              type="textarea"
              :rows="20"
              placeholder="Введите описание конкурса"
              v-model="currentVacancy.description">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </span>
  </div>
</template>

<script>
  import config from '../../appsettings.js'
  import layout from '../../api/helpers/layout'
  import grid from '../../api/helpers/grid'
  import rules from '../../api/rules/vacancy'
  import extension from '../../api/helpers/file'

  export default {
    name: 'vacancyview',
    props: ['vv'],
    data() {
        return {
            loading: false,
            isReadOnly: false,
            currentVacancy: {
                uid: '',
                position: '',
                comitteeId: null,
                comitteeLabel: '',
                comittee: { id: null, label: '' },
                datePublish: null,
                dateOfContestPreliminary: null,
                dateOfContest: null,
                dateDocumentsAppliedFrom: null,
                dateDocumentsAppliedTo: null,
                dateOfSecondStage: null,
                place: '',
                contacts: '',
                status: 0,
                statusLabel: '',
                contestType: null,
                contestTypeLabel: '',
                description: '',
                isAlreadyApplied: false,
                candidates: []
            },
            comittees: [],
            contestTypes: [],
            statuses: [],
            fileList: [],
            uploadUrl: '',
            vacancyToEnroll: null,
            uploadRequestHeaders: null,
            attachmentToUpload: null,
            docDialogVisible: false,
            ///RULES
            dateDocumentsAppliedFrom: [
                {
                    required: true, validator: (rule, value, callback) => {
                        if (value) {
                            let date = new Date(new Date().toDateString());
                            let fromDate = new Date(value);
                            var dateFormat = require('dateformat');
                            //if (fromDate < date)
                            //    return callback(new Error('Дата начала подачи заявок на конкурс не может быть меньше текущей даты'));
                            let toDate = null;
                            if (this.currentVacancy && this.currentVacancy.dateDocumentsAppliedTo)
                                toDate = this.currentVacancy.dateDocumentsAppliedTo;
                            if (!toDate)
                                return callback(new Error('Введите пожалуйста, дату окончания подачи заявок на конкурс'));

                            if (fromDate >= toDate)
                                return callback("Дата окончания подачи заявок должна быть больше даты начала");

                            return callback();
                        } else
                            return callback(new Error('Введите пожалуйста, дату начала подачи заявок на конкурс'));
                    }, trigger: 'change'
                }
            ]
        }
    },
    computed: {
      vacancyRules: function() {
        let r = rules.getVacancyRules()
        r.dateDocumentsAppliedFrom = this.dateDocumentsAppliedFrom;
        return r;
      },
      isStatusReadOnly: function(){
        return !(this.currentVacancy && this.currentVacancy.uid);
      }
    },
    methods: {
      reset() {
        this.currentVacancy = {
          uid: '',
          position: '',
          comitteeId: null,
          comitteeLabel: '',
          comittee: { id: null, label: '' },
          datePublish: null,
          dateOfContestPreliminary: null,
          dateOfContest: null,
          dateDocumentsAppliedFrom: null,
          dateDocumentsAppliedTo: null,
          dateOfSecondStage: null,
          place: '',
          contacts: '',
          status: 0,
          statusLabel: '',
          contestType: null,
          contestTypeLabel: '',
          description: '',
          isAlreadyApplied: false,
          candidates: []
        };
      },
      save() {
        this.$refs['vacancy'].validate((valid) => {
          if (valid) {
            if(this.currentVacancy) {
              this.$gf.getOptions().then(options => {
                options.params = { };
                let self = this;
                let prefix = config.API_PREFIX;
                if(this.currentVacancy.uid === '') {
                  this.currentVacancy.datePublish = new Date();
                  self.$http.post(`${prefix}vacancy`, this.currentVacancy, options).then(response => {
                    this.$router.push(config.VACANCY_URL);
                    this.showSuccessMessage2();
                  }).catch(data => {
                    this.loading = false;
                    self.$gf.checkError(data)
                  });
                } else {
                  self.$http.put(`${prefix}vacancy`, this.currentVacancy, options).then(response => {
                    this.$router.push(config.VACANCY_URL);
                    this.showSuccessMessage2();
                  }).catch(data => {
                    this.loading = false;
                    self.$gf.checkError(data)
                  });
                }
              });
            }
          }
        });
      },
      enroll() {
        this.$confirm(`Вы действительно хотите подать заявку на конкурс на должность: '${this.currentVacancy.position}'?`, 'Информация', {
          confirmButtonText: 'Да',
          cancelButtonText: 'Нет',
          type: 'info'
        }).then(() => {
          let self = this;
          let prefix = config.API_PREFIX;
          this.vacancyToEnroll = this.currentVacancy.uid;
          if(this.currentVacancy.isAlreadyApplied) {
            this.$confirm('Хотите загрузить новое заявление на участие в конкурсе?', 'Информация', {
              confirmButtonText: 'Да, загрузить новое',
              cancelButtonText: 'Нет, не требуется',
              type: 'info'
            }).then(() => {
              this.uploadUrl = `${config.API_PREFIX}vacancycandidate/${this.vacancyToEnroll}/attachments`;
              this.docDialogVisible = true;
            }).catch(() => {
              this.$gf.getOptions().then(options => {
                this.loading = true;
                options.params = { };
                let self = this;
                let prefix = config.API_PREFIX;
                self.$http.post(`${prefix}vacancycandidate/${this.vacancyToEnroll}`, [], options).then(response => {
                  this.loading = false;
                  this.$router.push(config.VACANCY_URL);
                  this.showSuccessMessage();
                }).catch(data => {
                  this.loading = false;
                  self.$gf.checkError(data)
                });
              }).catch(err => this.$gf.catchOptions());
            });
          } else {
            this.uploadUrl = `${config.API_PREFIX}vacancycandidate/${this.vacancyToEnroll}/attachments`;
            this.docDialogVisible = true;
          }
        }).catch(() => {

        });
      },
      cancel() {
        if(this.isReadOnly) {
          this.$router.push(config.VACANCY_URL);
        } else {
          this.$confirm('Вы действительно хотите покинуть страницу? Изменения не будут учтены', 'Предупреждение', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Отмена',
            type: 'warning'
          }).then(() => {
            this.$router.push(config.VACANCY_URL);
          }).catch(() => {

          });
        }
      },
      fetch(uid) {
        this.loading = true;
        let self = this;
        let prefix = config.API_PREFIX;
        this.$gf.getOptions().then(options => {
          options.params = {
          };
          ///VACANCY
          if(uid && uid !== '0') {
              let url = this.isReadOnly ? `${prefix}vacancycandidate/${uid}` : `${prefix}vacancy/${uid}`;
              self.$http.get(url, options)
                .then(response => {
                  self.currentVacancy = response.data;
                  self.loading = false;
                })
                .catch(data => {
                  self.$gf.checkError(data);
                  self.loading = false;
                });
          }
          ///COMBOS
          if(!this.isReadOnly) {
          self.$http.get(`${prefix}vacancy/statuses`, options)
            .then(response => {
              self.statuses = response.data;
              self.loading = false;
            })
            .catch(data => {
              self.$gf.checkError(data);
              self.loading = false;
            });
            self.$http.get(`${prefix}vacancy/comittees`, options)
              .then(response => {
                self.comittees = response.data;
                self.loading = false;
              })
              .catch(data => {
                self.$gf.checkError(data);
                self.loading = false;
              });
              self.$http.get(`${prefix}vacancy/contesttypes`, options)
                .then(response => {
                  self.contestTypes = response.data;
                  self.loading = false;
                })
                .catch(data => {
                  self.$gf.checkError(data);
                  self.loading = false;
                });
          }
        }).catch(err => {
          this.$gf.catchOptions();
          this.loading = false;
        });
      },
      acceptAttachment() {
        this.uploadDocs();
      },
      cancelAttachment() {
        this.fileList = [];
        this.attachmentToUpload = null;
        this.docDialogVisible = false;
      },
      uploadDocs() {
        if(true) {
          this.$gf.getOptions().then(options => {
            this.loading = true;
            options.params = { };
            this.uploadRequestHeaders = options.headers;
            let self = this;
            let prefix = config.API_PREFIX;
            self.$http.post(`${prefix}vacancycandidate/${this.vacancyToEnroll}`, [], options).then(response => {
              this.$refs.upload.submit();
              this.docDialogVisible = false;
              this.loading = false;
            }).catch(data => {
              this.loading = false;
              self.$gf.checkError(data)
            });
          }).catch(err => this.$gf.catchOptions());
        } else {
          this.$message({
             message: 'Заполните полностью анкету и прикрепите к ней все необходимые документы',
             type: 'warning'
          });
        }
      },
      uploadSuccess(response, file, fileList) {
        this.loading = true;
        this.fileList = [];
        this.attachmentToUpload = null;
        this.docDialogVisible = false;
        this.loading = false;
        this.$router.push(config.VACANCY_URL);
        this.showSuccessMessage();
      },
      showSuccessMessage() {
        this.$message({
          message: 'Вы успешно записались на конкурс',
          type: 'success'
        });
      },
      showSuccessMessage2() {
        this.$message({
          message: 'Вы успешно сохранили конкурс',
          type: 'success'
        });
      },
      showErrorMessage() {
        //this.$message.error('Вы успешно отменили запись на конкурс');
        this.$message({
          message: 'Вы успешно отменили запись на конкурс',
          type: 'success'
        });
      },
      uploadError(err, file, fileList) {
        this.loading = false;
      },
      beforeUpload(file) {
        let ext = extension.getExtension(file.name);
        ext = ext ? ext.toLowerCase() : ext;
        const isImage = ext && (ext === 'jpeg' || ext === 'jpg' || ext === 'png' || ext === 'pdf');
        const isLt5Mb = file.size / 1024 / 1024 <= 5;
        if (!isImage) {
          this.$message.error('Документ должен быть в формате jpg/jpeg/png/pdf');
        }
        if (!isLt5Mb) {
          this.$message.error('Размер документа должен быть меньше 5MB');
        }
        return isImage && isLt5Mb;
      },
      changeFileList(file, fileList) {
        let add = this.beforeUpload(file);
        if(!add) {
          fileList.splice(-1, 1);
        } else {
          if(fileList && fileList.length > 1) {
              this.$message.error('Количество документов не должно превышать 1');
              fileList.splice(-1, 1);
          }
        }
      },
      resize() {
        let height = layout.getParentClientHeight();

      },
      formatDate(d) {
        return grid.formatDate(d);
      }
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resize);
    },
    created() {
      window.addEventListener('resize', this.resize);
      let path = this.$route.path;
      if(path && path.includes('vacancy/view/'))
        this.isReadOnly = true;
      this.fetch(this.vv);
      if(!this.vv)
        this.reset();
    }
  }
</script>

<style scoped>
  .vacancyview {
    height: calc(100% - 20px);
    border: 1px solid #d1dbe5;
    padding: 10px;
    overflow-y: scroll;
  }
  .readonly .el-form-item {
    margin-bottom: 0px !important;
  }
</style>
<style>
  .el-picker-panel {
    min-width: 350px !important;
  }
  .el-upload {
    width: 100% !important;
  }
  .el-upload-dragger {
    width: 100% !important;
    min-width: 360px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/personalarea/vacancyview.vue